module.exports = __webpack_public_path__ + "img/normal_icon.2793bb29.png";